// Time conversion utilities
export function timeToSeconds(timeStr: string): number {
  const [minutes, seconds] = timeStr.split(':').map(Number);
  return minutes * 60 + seconds;
}

export function isTimeInRange(time: number, start: number, end: number): boolean {
  return time >= start && time < end;
}